export default __webpack_public_path__ + "static/media/ico-lcd-screens.a5b273d8.svg";